// transform axios exception to the object is intended to be stored in redux store
export const axiosExceptionToFailure = (ex) => {
  const { response: { data: { code, message } = {} } = {} } = ex;
  return {
    message,
    code,
  };
};
